/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CoreApiConfiguration, CoreApiConfigurationParams } from './core-api-configuration';

import { ApprovalReportService } from './services/approval-report.service';
import { ChangeNotificationsService } from './services/change-notifications.service';
import { ContainersService } from './services/containers.service';
import { DocumentManagementService } from './services/document-management.service';
import { DowntimesService } from './services/downtimes.service';
import { EmployeeRegistrationService } from './services/employee-registration.service';
import { EmployeeSignatureService } from './services/employee-signature.service';
import { FrontendConfigService } from './services/frontend-config.service';
import { MachineService } from './services/machine.service';
import { MachineScheduleService } from './services/machine-schedule.service';
import { MaintenanceService } from './services/maintenance.service';
import { MaterialService } from './services/material.service';
import { MeasurementService } from './services/measurement.service';
import { PackLineService } from './services/pack-line.service';
import { PatternInfoService } from './services/pattern-info.service';
import { PileTurnerService } from './services/pile-turner.service';
import { PrimaryMaterialService } from './services/primary-material.service';
import { PrintLabelService } from './services/print-label.service';
import { ProducedMaterialService } from './services/produced-material.service';
import { ProductionOrderService } from './services/production-order.service';
import { QaCheckService } from './services/qa-check.service';
import { QualityHistoryService } from './services/quality-history.service';
import { RemarkService } from './services/remark.service';
import { SecondaryMaterialService } from './services/secondary-material.service';
import { SettingsService } from './services/settings.service';
import { SetupParameterService } from './services/setup-parameter.service';
import { ShiftReportService } from './services/shift-report.service';
import { SimulationService } from './services/simulation.service';
import { TasksService } from './services/tasks.service';
import { ToolService } from './services/tool.service';
import { TraceabilityService } from './services/traceability.service';
import { TraceMaterialService } from './services/trace-material.service';
import { VirtualContainerService } from './services/virtual-container.service';
import { WasteAssignmentService } from './services/waste-assignment.service';
import { WorkCenterService } from './services/work-center.service';
import { WorkCenterGroupService } from './services/work-center-group.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ApprovalReportService,
    ChangeNotificationsService,
    ContainersService,
    DocumentManagementService,
    DowntimesService,
    EmployeeRegistrationService,
    EmployeeSignatureService,
    FrontendConfigService,
    MachineService,
    MachineScheduleService,
    MaintenanceService,
    MaterialService,
    MeasurementService,
    PackLineService,
    PatternInfoService,
    PileTurnerService,
    PrimaryMaterialService,
    PrintLabelService,
    ProducedMaterialService,
    ProductionOrderService,
    QaCheckService,
    QualityHistoryService,
    RemarkService,
    SecondaryMaterialService,
    SettingsService,
    SetupParameterService,
    ShiftReportService,
    SimulationService,
    TasksService,
    ToolService,
    TraceabilityService,
    TraceMaterialService,
    VirtualContainerService,
    WasteAssignmentService,
    WorkCenterService,
    WorkCenterGroupService,
    CoreApiConfiguration
  ],
})
export class CoreApiModule {
  static forRoot(params: CoreApiConfigurationParams): ModuleWithProviders<CoreApiModule> {
    return {
      ngModule: CoreApiModule,
      providers: [
        {
          provide: CoreApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: CoreApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CoreApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
